import { InvoiceSidePanelTabFiles } from './InvoiceSidePanelTabFiles';
import { InvoiceSidePanelTabChat } from './InvoiceSidePanelTabChat';
import { EntityType, FileBase } from '../../../types/Files';
import { TabsComponent } from '../../../components/tabs/Tabs';
import { convertEnumToArray } from '../../../utils/functions/data.functions';
import { InvoiceSidePanelTabLinkedDocuments } from './InvoiceSidePanelTabLinkedDocuments';
import { InvoiceSidePanelTabOptionalFields } from './InvoiceSidePanelTabOptionalFiled';
import { DirectionDoc, InvoiceBaseInputs } from '../../../types/Invoice';
import { SmartAttachmentPage } from '../SmartAttachment/SmartAttachmentPage';
import useSessionStorage from '../../../hooks/useSessionStorage';
import { sessionStorageKeys } from '../../../utils/keys/sessionStorageKeys';
import { InvoiceSidePanelTabPayments } from './InvoiceSidePanelTabPayments';
import FilePreview from '../../../components/filePreview/FilePreview';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../../api/apiUrl';
import { useCurrentCompany } from '../../../hooks/useCompany';
import http from '../../../api/axios';

interface Props {
  entityId: string;
  // TODO
  // Entity type není typ dokumentu
  // Files se prozatím getují jen pro typ "Invoice" --> nastaveno na pevno na 'Invoice', v budoucnu změnit, proto zatím nepovinné
  entityType?: EntityType;
  data: InvoiceBaseInputs;
  mutate?: () => void;
}

export enum INVOICE_TABS {
  MINED_FILE = 'tab-mined-file',
  FILES = 'tab-files',
  LINKED_DOCUMENTS = 'tab-linked-documents',
  CHAT = 'tab-chat',
  OPTIONAL_FIELDS = 'tab-optional-fields',
  SMART_ATTACHMENTS = 'tab-smart-attachments',
  PAYMENTS = 'tab-payments',
}

/**
 * Invoice side panel with tabs related to invoice
 */
export const InvoiceSidePanel = ({
  entityId,
  entityType = EntityType.ACCOUNTING_DOCUMENT,
  data,
  mutate,
}: Props) => {
  const { company } = useCurrentCompany();
  const [files, setFiles] = useState<FileBase[] | null>(null);
  const [activeTab, setActiveTab] = useSessionStorage<string>(
    sessionStorageKeys.INVOICE_ACTIVE_TAB,
    INVOICE_TABS.FILES,
  );

  /**
   * Loads files for current invoice/receipt
   */
  const fetchFiles = async () => {
    if (!company || !entityId) return;
    let req = `?companyId=${company.id}`;
    if (entityType) req += `&entityType=${EntityType.ACCOUNTING_DOCUMENT}`;
    if (entityId) req += `&entityId=${entityId}`;
    const response = await http.apiGet({
      url: `${apiUrl.FILE_LIST}${req}`,
    });
    setFiles(response?.data);
  };

  useEffect(() => {
    if (activeTab === INVOICE_TABS.MINED_FILE) fetchFiles();
  }, [activeTab]);

  /**
   * Function to handle tab changes
   * @param tab
   */
  const handleChangeTab = (tab: string) => setActiveTab(tab);

  return (
    <div className="mt-5 py-2 px-1 overflow-auto w-1/2">
      <TabsComponent
        activeTab={activeTab}
        setActiveTab={handleChangeTab}
        tabs={convertEnumToArray(INVOICE_TABS)}
      >
        {files && files.length > 0 && data?.direction === DirectionDoc.UNKNOWN ? (
          <div key={INVOICE_TABS.MINED_FILE}>
            <FilePreview id={files[0].id} />
          </div>
        ) : (
          <>aaa</>
        )}

        <div key={INVOICE_TABS.FILES}>
          <InvoiceSidePanelTabFiles
            entityId={entityId}
            entityType={entityType}
            files={files}
            setFiles={setFiles}
            fetchFiles={fetchFiles}
          />
        </div>
        <div key={INVOICE_TABS.LINKED_DOCUMENTS}>
          <InvoiceSidePanelTabLinkedDocuments document={data ?? []} mutate={mutate} />
        </div>
        <div key={INVOICE_TABS.CHAT}>
          <InvoiceSidePanelTabChat />
        </div>
        <div key={INVOICE_TABS.OPTIONAL_FIELDS}>
          <InvoiceSidePanelTabOptionalFields document={data ?? []} mutate={mutate} />
        </div>
        <div key={INVOICE_TABS.SMART_ATTACHMENTS}>
          <SmartAttachmentPage />
        </div>
        <div key={INVOICE_TABS.PAYMENTS}>
          <InvoiceSidePanelTabPayments document={data ?? []} />
        </div>
      </TabsComponent>
    </div>
  );
};
